import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Typography, Table, Tag, Spin } from 'antd';
import {
  CalendarOutlined,
  TeamOutlined,
  WarningOutlined,
  StopOutlined,
} from '@ant-design/icons';
import { getDashboardStats } from '../../services/adminService';

const { Title } = Typography;

const DashboardPage = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await getDashboardStats({});
        setStats(data.stats);
      } catch (err) {
        console.error('Error fetching stats:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '80px auto' }} />;

  const kpis = [
    { title: 'Total RDV', value: stats?.total || 0, icon: <CalendarOutlined />, color: '#059669', bg: '#ecfdf5' },
    { title: 'Équipes actives', value: stats?.activeTeams || 0, icon: <TeamOutlined />, color: '#0284c7', bg: '#e0f2fe' },
    { title: 'Absences en cours', value: stats?.currentAbsences || 0, icon: <StopOutlined />, color: '#ea580c', bg: '#fff7ed' },
    { title: 'Warnings distance', value: stats?.distanceWarnings || 0, icon: <WarningOutlined />, color: '#dc2626', bg: '#fef2f2' },
  ];

  const teamColumns = [
    { title: 'Équipe', dataIndex: 'nom', key: 'nom', render: (text, record) => (
      <Tag color={record.couleur}>{text}</Tag>
    )},
    { title: 'Groupe', dataIndex: 'groupe', key: 'groupe' },
    { title: 'RDV', dataIndex: 'count', key: 'count', sorter: (a, b) => a.count - b.count },
  ];

  return (
    <div>
      <Title level={4} style={{ marginBottom: 24 }}>Dashboard</Title>

      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        {kpis.map((kpi, i) => (
          <Col xs={12} sm={6} key={i}>
            <Card styles={{ body: { padding: 20 } }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 44, height: 44, borderRadius: 10,
                  background: kpi.bg, display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  color: kpi.color, fontSize: 20,
                }}>
                  {kpi.icon}
                </div>
                <Statistic title={kpi.title} value={kpi.value} valueStyle={{ color: kpi.color, fontSize: 24 }} />
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title="RDV par équipe">
            <Table
              dataSource={stats?.byTeam || []}
              columns={teamColumns}
              pagination={false}
              size="small"
              rowKey="nom"
            />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="RDV par jour">
            <Table
              dataSource={stats?.byDate || []}
              columns={[
                { title: 'Date', dataIndex: 'date_rdv', key: 'date_rdv',
                  render: (d) => new Date(d).toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })
                },
                { title: 'Nombre', dataIndex: 'count', key: 'count' },
              ]}
              pagination={false}
              size="small"
              rowKey="date_rdv"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardPage;
